import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplierQuotations, SupplierQuotation } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplierQuotationsModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplierQuotation> useData={useSupplierQuotations} config={config} />;
};

export default List;

